/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import React, { useState, useEffect, useRef } from 'react';
import { AddCircleIcon, BackArrow, CircleFilled, DeleteIcon, EditIcon, HorizontalThreeDot, RemoveUserIcon, SearchLineIcon } from '@mybridge/icons';
import { Input } from '@mybridge/ui/input';
// import Dropdown from 'v4/components/common/Dropdown';
import {
  Box,
  Flex,
  Heading,
  Image,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Radio,
  Select,
  List,
  ListItem,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  HStack,
  Avatar,
  VStack,
  Spinner,
  Card,
  CardBody,
  Stack,
  Spacer,
} from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';
import {
  addTeam,
  deleteTeam,
  getPages,
  teamList,
  updateTeam,
} from 'v4/store/actions/permissions.actions';
import { useDispatch, useSelector } from 'react-redux';
import _, { replace, startCase } from 'lodash';
import { Link } from '@mybridge/ui';
import { Text } from '@mybridge/ui/text';

import { useRouter, useSearchParams } from 'next/navigation';
import { Checkbox, Divider, IconButton, InputGroup, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Portal, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import PermissionImg from 'v4/assets/permissions.svg';
import { searchItem } from 'v4/store/slices/searchSlice';
import { useDisclosure } from '@mybridge/ui/hooks';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import { useToast } from '@chakra-ui/react';
import NextLink from 'next/link';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { isMobile } from 'react-device-detect';
import Head from 'next/head';
import { MyNetworkUserCardBordered } from 'v4/components/network/network-card-new';
import { UserNetworkingActions } from 'v4/components/user-networking-actions';
import { getUserFullName, getUserProfilePic } from 'v4/lib/commons';
 import { AddIcon } from '@chakra-ui/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';

const ERROR_VALUES = {
  teamMate: 'Please enter a Valid name or email',
  companyPage: 'Select a page',
  role: 'Please select a role',
};
export default function Team({ setSelectedComponent }) {
  const { isTeamUpdated, loading, teamInfo, pages, msg } = useSelector(
    (state) => state.permissionsReducer
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const dropdownRef = useRef(null);
  const { loggedIn, pageLoaded } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const [showTeams, setShowTeams] = useState(true);
  const [addOpen, setAddOpen] = useState(false);
  const [fields, setFields] = useState({});
  const dispatch = useDispatch();
  const { push } = useRouter();
  const [errorFields, setErrorFields] = useState({});
  const [currentTeamId, setCurrentTeamId] = useState(null);
  const [companyPages, setCompanyPages] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState();
  const inputRef = useRef();
  const containerRef = useRef();
  const disc = useDisclosure();
  const toast = useToast();
  const [companyName, setCompanyName] = useState(null);
  const [showAllCards, setShowAllCards] = useState(false);
  const discAlert = useDisclosure();
  const { t } = useTranslator();
  const direction = useDirection();
  useEffect(() => {
    dispatch(getPages());
    dispatch(teamList());
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isTeamUpdated) {
      dispatch(teamList());
      setShowTeams(true);
      handleClickScroll();
    }
  }, [isTeamUpdated]);

  useEffect(() => {
    if (pages) {
      const page = pages?.results?.map(({ name, id, access_type }) => {
        return {
          label: name,
          id,
          value: id,
          access_type
        };
      });
      setCompanyPages(page);
    }
  }, [pages]);

  const fieldsOnChange = (e) => {
    setSearchQuery(e.target.value);
    dispatch(
      searchItem({
        searchQuery: e.target.value,
        query: `&custom_param_name=mycircle`,
        item: 'people',
      })
    ).then((res) => {
      setOptions(res.payload.results);
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((prevValues) => ({ ...prevValues, [name]: value }));
    setErrorFields((prevErrors) => ({ ...prevErrors, [name]: undefined }));
  };
  const goToCreate = () => {
    setAddOpen(false);
    push('/page/create');
  };

  // Add these state variables with your other useState declarations
const [inviteModalOpen, setInviteModalOpen] = useState(false);
const [inviteSearch, setInviteSearch] = useState('');
const [inviteOptions, setInviteOptions] = useState([]);
const [selectedConnections, setSelectedConnections] = useState([]);

// Add these functions to handle the invite modal functionality
const openInviteModal = () => {
  setInviteModalOpen(true);
  
  // Load connections immediately when modal opens
  dispatch(
    searchItem({
      searchQuery: '', // Empty search query to get all connections
      query: `&custom_param_name=mycircle`,
      item: 'people',
    })
  ).then((res) => {
    if (res.payload && res.payload.results) {
      setInviteOptions(res.payload.results);
    }
  });
};

const handleInviteSearch = (e) => {
  const searchValue = e.target.value;
  setInviteSearch(searchValue);
  
  // If search value is not empty, filter connections
  if (searchValue.trim()) {
    dispatch(
      searchItem({
        searchQuery: searchValue,
        query: `&custom_param_name=mycircle`,
        item: 'people',
      })
    ).then((res) => {
      setInviteOptions(res.payload.results);
    });
  } else {
    // If search is cleared, load all connections again
    dispatch(
      searchItem({
        searchQuery: '',
        query: `&custom_param_name=mycircle`,
        item: 'people',
      })
    ).then((res) => {
      setInviteOptions(res.payload.results);
    });
  }
};

const closeInviteModal = () => {
  setInviteModalOpen(false);
  setSelectedConnections([]); // Reset selected connections
  setInviteSearch(''); // Also reset the search input
};

const toggleSelectedConnection = (item) => {
  const itemId = item?.id;
  const isSelected = selectedConnections.some(
    (selectedItem) => selectedItem.id === itemId
  );
  
  if (isSelected) {
    const updatedSelected = selectedConnections.filter(
      (selectedItem) => selectedItem.id !== itemId
    );
    setSelectedConnections(updatedSelected);
  } else {
    setSelectedConnections([...selectedConnections, item]);
  }
};

const handleInviteConfirm = () => {
  if (selectedConnections.length > 0) {
    // Create a comma-separated list of names
    const selectedNames = selectedConnections.map(user => 
      `${user.first_name} ${user.last_name}`
    ).join(', ');
    
    // Create a comma-separated list of emails
    const selectedEmails = selectedConnections.map(user => user.email).join(', ');
    
    // Update the UI with the selected names
    setSearchQuery(selectedNames);
    
    // Update the form fields with the selected emails
    setFields((prevValues) => ({ ...prevValues, teamMate: selectedEmails }));
    
    // Store all selected users for later use
    setSelected(selectedConnections);
    
    // Close the modal and reset selections
    setInviteModalOpen(false);
    setSelectedConnections([]);
    setInviteSearch('');
  }
};

  // const saveTeam = () => {
  //   const { companyPage, role, teamMate } = fields;
  //   const errorObject = {};
  //   if (!teamMate) {
  //     errorObject.teamMate = ERROR_VALUES.teamMate;
  //   }
  //   if (!companyPage) {
  //     errorObject.companyPage = ERROR_VALUES.companyPage;
  //   }
  //   if (!role) {
  //     errorObject.role = ERROR_VALUES.role;
  //   }

  //   if (Object.keys(errorObject).length > 0) {
  //     setErrorFields(errorObject);
  //     return;
  //   } else {
  //     setErrorFields({});
  //   }

  //   let payload = {};
  //   if (currentTeamId) {
  //     payload = {
  //       id: currentTeamId,
  //       teammate: teamMate,
  //       company_page: Number(companyPage),
  //       access: role,
  //       active: true,
  //     };
  //     payload.id = currentTeamId;
  //     dispatch(updateTeam(payload));
  //     setFields({});
  //     setSelected();
  //     setCurrentTeamId(null);
  //   } else {
  //     payload = {
  //       teammate: selected.email,
  //       company_page: Number(companyPage),
  //       access: role,
  //       active: true,
  //     };
  //     dispatch(addTeam(payload));
  //     setFields({});
  //     setSelected();
  //     setCurrentTeamId(null);
  //     setIsEditing(false);
  //   }
  // };

  const saveTeam = () => {
    const { companyPage, role, teamMate } = fields;
    const errorObject = {};
    
    if (!teamMate) {
      errorObject.teamMate = ERROR_VALUES.teamMate;
    }
    if (!companyPage) {
      errorObject.companyPage = ERROR_VALUES.companyPage;
    }
    if (!role) {
      errorObject.role = ERROR_VALUES.role;
    }
  
    if (Object.keys(errorObject).length > 0) {
      setErrorFields(errorObject);
      return;
    } else {
      setErrorFields({});
    }
  
    // Check if we're dealing with multiple teammates (comma-separated emails)
    const emails = teamMate.split(',').map(email => email.trim());
    
    if (currentTeamId) {
      // For editing, we still handle a single user
      const payload = {
        id: currentTeamId,
        teammate: teamMate,
        company_page: Number(companyPage),
        access: role,
        active: true,
      };
      dispatch(updateTeam(payload)).then(res => {
        if(res?.payload?.id){
          toast({
            title: "Permission update successfully",
            status: 'success',
            isClosable: true,
            position: 'top',
          });
        }else if(res?.payload?.status_code >= 400){
          toast({
            description: res?.payload?.detail,
            status: 'error',
            isClosable: true,
            position: 'top',
          });
        }
      });
      setFields({});
      setSelected(null);
      setCurrentTeamId(null);
    } else {
      // For adding new users, handle multiple emails if present
      if (emails.length > 1) {
        // Create a promise array for multiple invites
        const invitePromises = emails.map(email => {
          const payload = {
            teammate: email,
            company_page: Number(companyPage),
            access: role,
            active: true,
          };
          return dispatch(addTeam(payload));
        });
        
        // Execute all invites and handle completion
        Promise.all(invitePromises).then(() => {
          toast({
            title: `${emails.length} ${t('otherModules.team_members_added') || "team members added successfully!"}`,

            status: 'success',
            isClosable: true,
            position: 'top',
          });
          dispatch(teamList());
        });
      } else {
        // Single user invite
        const payload = {
          teammate: teamMate,
          company_page: Number(companyPage),
          access: role,
          active: true,
        };
        dispatch(addTeam(payload)).then(res => {
          if(res?.payload?.status_code >= 400){
            toast({
              description: res?.payload?.detail,
              status: 'error',
              isClosable: true,
              position: 'top',
            });
          }else if(res?.payload?.id){
            toast({
              title: "Permission Added successfully",
              status: 'success',
              isClosable: true,
              position: 'top',
            });
          }
        });
      }
      
      setFields({});
      setSelected(null);
      setCurrentTeamId(null);
      setIsEditing(false);
    }
  };
  
  const cancelTeam = () => {
    setCurrentTeamId(null);
    setShowTeams(true); // Show the team list and default image when canceling
    setFields({});
    setAddOpen(false);
    setIsEditing(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const editTeam = (id) => {
    setErrorFields({});
    setShowTeams(false);
    setCurrentTeamId(id);
    // handleClickScroll();
    const currentTeam = teamInfo?.result?.find((t) => t.id === id);
    setFields({
      role: currentTeam.access,
      companyPage: currentTeam.company_page,
      teamMate: currentTeam.teammate,
    });
    setSearchQuery(currentTeam?.team_detail?.full_name);
    setAddOpen(true);
    setIsEditing(true);
  };

  const askDeleteItem = (team) => {
    setCompanyName(team);
    discAlert.onOpen();
  };

  const handleDeleteTeam = (id) => {
    dispatch(deleteTeam(id)).then((res) => {
      if(res?.payload?.status_code>=400){
        toast({
          description: res?.payload?.detail?? "Faild to Delete",
          status: 'error',
          isClosable: true,
          position: 'top',
        });
      }else {
        toast({
          title: t('otherModules.team_member_deleted') || `Team member deleted successfully!`,
          status: 'success',
          isClosable: true,
          position: 'top',
        });
      }
    });
    setShowTeams(true);
    discAlert.onClose();
    setTimeout(function () {
      dispatch(teamList());
    }, 1000);
  };

  const radioChangeHandler = (e) => {
    const { name, value } = e.target;
    setFields((prevValues) => ({ ...prevValues, [name]: value }));
    setErrorFields((prevErrors) => ({ ...prevErrors, [name]: undefined }));
  };

  const handleClickScroll = () => {
    setSearchQuery('')
    if (addOpen) {
      setAddOpen(false);
      // window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      setAddOpen(true);
      setShowTeams(false); // Hide the team list and default image when opening add form
      setFields({});
      setIsEditing(false);
      setErrorFields({});
      
      // Wait for the addOpen section to render completely
      // setTimeout(() => {
      //   const element = document.getElementById('addMemberCompany');
      //   if (element) {
      //     // Get the full height including margins and padding
      //     const elementRect = element.getBoundingClientRect();
      //     const absoluteElementBottom = window.pageYOffset + elementRect.bottom;
          
      //     window.scrollTo({
      //       top: absoluteElementBottom,
      //       behavior: 'smooth'
      //     });
      //   }
      //   const eles = document.querySelectorAll('input');
      //   if (eles) {
      //     eles.forEach((item) => (item.value = ''));
      //   }
      // }, 100);
    }
  };

  // const handleSelect = (item) => () => {
  //   if (item) {
  //     setSelected(item);
  //     setSearchQuery(`${item.first_name} ${item.last_name}`);
  //     setFields((prevValues) => ({ ...prevValues, teamMate: item.email }));
  //     // disc?.onClose?.();
  //     setIsDropdownOpen(false);
  //   }
  // };
  const handleSelect = (item) => () => {
    if (item) {
      // If we're in edit mode, just select one user
      if (isEditing) {
        setSelected(item);
        setSearchQuery(`${item.first_name} ${item.last_name}`);
        setFields((prevValues) => ({ ...prevValues, teamMate: item.email }));
      } else {
        // For new invites, we can handle multiple selections
        // Check if this user is already selected
        const isAlreadySelected = selected && 
          (Array.isArray(selected) 
            ? selected.some(sel => sel.id === item.id)
            : selected.id === item.id);
        
        if (!isAlreadySelected) {
          // Create a new array of selected users
          const newSelected = Array.isArray(selected) ? [...selected, item] : [item];
          
          // Create a comma-separated list of names
          const selectedNames = newSelected.map(user => 
            `${user.first_name} ${user.last_name}`
          ).join(', ');
          
          // Create a comma-separated list of emails
          const selectedEmails = newSelected.map(user => user.email).join(', ');
          
          // Update the UI and form
          setSelected(newSelected);
          setSearchQuery(selectedNames);
          setFields((prevValues) => ({ ...prevValues, teamMate: selectedEmails }));
        }
      }
      
      // Close the dropdown
      setIsDropdownOpen(false);
    }
  };

  return (
    <AuthenticatedProviders>
      <Head>
        <title>
          {loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''} {t('setting.account') || "Account"}
          - {t('setting.permissions') || "Permissions"} | myBridge.me
        </title>
      </Head>
      {!loading ? (
        <Box padding = "0 5%" className="user-settings--team" height="100%">
          {currentTeamId ? (
            ''
          ) : (
            <Heading
              as="h4"
              size="md"
              p={['0px 10px', '0 0 10px']}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Spacer />
              {showTeams && (
                <Button variant="ghost" onClick={() => handleClickScroll()}>
                  <Text fontSize="16px" fontWeight="400" color="#333333" me="10px">{t('settingsPermission.addNewUser') || "Add new user"}</Text>
                  <CircleFilled color="#3D5A80" />
                </Button>
              )}
            </Heading>
          )}
          {currentTeamId ? (
            ''
          ) : showTeams && teamInfo?.result?.length > 0 ? (
            <>
              {!isMobile ? (
                // <Table mb="20px">
                //   <Thead>
                //     <Tr
                //       backgroundColor="brandGray.400"
                //       border="1px solid"
                //       borderColor="brandGray.400"
                //     >
                //       <Th
                //         color="black"
                //         textTransform="capitalize"
                //         fontSize="sm"
                //         fontWeight="regular"
                //         py="20px"
                //       >
                //         <Text color="#333333">Name</Text>
                //       </Th>
                //       <Th
                //         color="black"
                //         textTransform="capitalize"
                //         fontSize="sm"
                //         fontWeight="regular"
                //         py="20px"
                //         minW="120px"
                //       >
                //         <Text color="#333333">Access</Text>
                //       </Th>
                //       <Th
                //         color="black"
                //         textTransform="capitalize"
                //         fontSize="sm"
                //         fontWeight="regular"
                //         py="20px"
                //       >
                //         <Text color="#333333">Page</Text>
                //       </Th>
                //       <Th
                //         color="black"
                //         textTransform="capitalize"
                //         fontSize="sm"
                //         fontWeight="regular"
                //         py="20px"
                //         minW="100px"
                //       >
                //         <Text color="#333333">Status</Text>
                //       </Th>
                //       {/* <Th
                //         color="black"
                //         textTransform="capitalize"
                //         fontSize="sm"
                //         fontWeight="regular"
                //         py="20px"
                //         className="text-center"
                //         minW="180px"
                //       >
                //         <Text color="#333333">Action</Text>
                //       </Th> */}
                //     </Tr>
                //   </Thead>
                //   <Tbody fontSize="sm">
                //     {teamInfo?.result?.map((team, index) => (
                //       <>
                //         {console.log(team)}
                //         <Tr key={index} border="1px solid #D9D9D9">
                //           <Td borderColor="#D9D9D9">
                //             <HStack>
                //               <Avatar
                //                 name={team?.team_detail?.full_name}
                //                 src={team?.team_detail?.profile_pic}
                //                 size="md"
                //               />
                //               <VStack
                //                 justifyContent="flex-start"
                //                 align="left"
                //                 gap={0}
                //               >
                //                 <Text
                //                   color="#3D5A80"
                //                   className="name"
                //                   width="80px"
                //                   fontSize="14px"
                //                   fontWeight="400"
                //                 >
                //                   {team?.team_detail?.full_name}
                //                 </Text>
                //               </VStack>
                //             </HStack>
                //           </Td>
                //           <Td borderColor="#D9D9D9">
                //             <Text color="#333333" fontWeight="400">
                //               {startCase(replace(team.access, '_', ' '))}
                //             </Text>
                //           </Td>
                //           <Td borderColor="#D9D9D9">
                //             <NextLink
                //               href={`/page/private/${team?.company_page}`}
                //               passHref
                //             >
                //               <Link>
                //                 <Text color="#333333" fontWeight="400">
                //                   {team?.company_name}
                //                 </Text>
                //               </Link>
                //             </NextLink>
                //           </Td>
                //           <Td borderColor="#D9D9D9">
                //             <Text color="#333333" fontWeight="400">
                //               {team.active ? 'Active' : 'Inactive'}
                //             </Text>
                //           </Td>
                //           {/* <Td borderColor="#D9D9D9">
                //           {team.access !== 'owner' && (
                //             <>
                //               <Button
                //                 fontSize="sm"
                //                 size="sm"
                //                 variant="ghost"
                //                 color="#3D5A80"
                //                 onClick={() => editTeam(team.id)}
                //                 fontWeight="400"
                //               >
                //                 Edit
                //               </Button>
                //               <span> | </span>
                //               <Button
                //                 fontSize="sm"
                //                 size="sm"
                //                 variant="ghost"
                //                 color="#3D5A80"
                //                 onClick={() => askDeleteItem(team)}
                //                 fontWeight="400"
                //               >
                //                 Delete
                //               </Button>
                //             </>
                //           )}
                //         </Td> */}
                //         </Tr>
                //       </>
                //     ))}
                //     {teamInfo?.result?.length === 1 && (
                //       <Tr>
                //         <Td colspan="5" align="center">
                //           You don&apos;t have any team members added. Please add
                //           teammates below.
                //         </Td>
                //       </Tr>
                //     )}
                //   </Tbody>
                // </Table>
                <Flex flexWrap="wrap" gap="16px" justifyContent="flex-start">
                  {teamInfo?.result?.map((team, index) => (
                    <Card
                    key={index}
                      variant="thinBorderedCard"
                      minW={['160', '148px']}
                      maxW={['none', '380px']}
                      w="380px"
                      // mb={"16px"}
                      overflow="hidden"
                      borderRadius="20px"
                      border="1px solid #D9D9D9"
                      boxShadow="0px 2px 6px 0px #00000033"
                      flex="0 0 calc(50% - 8px)" // This ensures 2 cards per row with gap
                      // maxH="240px"
                      minH="180px"
                      gap={"16px"}
                    >
                      <VStack
                        direction={['column', 'row']}
                        alignItems="flex-start"
                      >
                        <HStack p={"13px"} justifyContent="center" position="relative">
                          <Avatar
                            {...(team?.team_detail?.slug?.length ? { as: Link, href: '/p/' + team?.team_detail?.slug } : {})}
                            name={team?.team_detail?.full_name}
                            src={team?.team_detail?.profile_pic}
                            width="60px"
                            height="60px"
                            border="2px solid white"
                          />
                          <Stack>
                            <Stack spacing={0} flex={1} >
                              {team?.team_detail?.full_name ? (
                                <HStack>
                                  <Text
                                    fontSize={['24px', '18px', '18px', '24px']}
                                    fontWeight="400"
                                    color="#5B5B5B"
                                    textTransform="capitalize"
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    whiteSpace="nowrap"
                                    maxW="282px"
                                    {...(team?.team_detail?.slug?.length
                                      ? { as: Link, href: '/p/' + team?.team_detail?.slug }
                                      : {})}
                                  >
                                    {team?.team_detail?.full_name}
                                  </Text>
                                </HStack>
                              ) : null}
              
                              <Box>
                                <Stack minH="30px" spacing={0} >
                                  {team?.team_detail?.position ? (
                                    <>                                     
                                      <Text
                                        fontSize={['14px', '12px', '12px', '14px']}
                                        fontWeight="400"
                                        color="#868585"
                                        maxW="255px"
                                        overflow="hidden"
                                        textOverflow="ellipsis"
                                        whiteSpace="nowrap"
                                      >
                                        {team?.team_detail?.position}
                                      </Text>                                    
                                      <Text
                                        fontSize={['14px', '12px', '12px', '14px']}
                                        fontWeight="400"
                                        color="#868585"
                                        maxW="255px"
                                        overflow="hidden"
                                        textOverflow="ellipsis"
                                        whiteSpace="nowrap"
                                        cursor="pointer"
                                        onClick={() => {push(`/page/private/${team?.company_page}`)}}
                                      >
                                        {team?.company_name ??
                                          team?.company_name ??
                                          ''}
                                      </Text>
                                    </>
                                  ) : team?.educations?.length ? (                                  
                                    <Text
                                      fontSize={['14px', '12px', '12px', '14px']}
                                      maxW="160px"
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                      whiteSpace="nowrap"
                                    >
                                      {team?.educations?.[0]?.name}
                                    </Text>
                                  ) : (
                                    <>
                                      <Text fontSize={['14px', '12px', '12px', '14px']} textAlign="center">
                                        {team?.position?.length > 25
                                          ? team?.position?.slice(0, 25) + '...'
                                          : team?.position}
                                      </Text>
                                      
                                      <Text
                                        fontSize={['14px', '12px', '12px', '14px']}
                                        color="#868585"
                                        textAlign="start"
                                        cursor="pointer"
                                        onClick={() => {push(`/page/private/${team?.company_page}`)}}
                                      >
                                        {team?.company_name}
                                      </Text>
                                    </>
                                  )}
                                  {<Text
                                    fontSize={['14px', '12px', '12px', '14px']}
                                    fontWeight="400"
                                    color="#4170A4"
                                    maxW="255px"
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    whiteSpace="nowrap"
                                  >
                                    {team?.role_name ?? team?.access ?? ''}
                                  </Text>}
                                </Stack>
                              </Box>
              
                            
                            </Stack>
                          </Stack>
                        </HStack>
            
            
                        <HStack h="100%" w="100%" px={4} pb={5}>
                          <Button variant="none" borderRadius="27px" color="#00A84B" border="1px solid #00000033" w="91px" h="41px" fontSize={['14px', '12px', '12px', '14px']}>{team.active ? t('settingsPermission.active') || 'Active' : t('settingsPermission.inactive') || 'Inactive'}</Button>
                          {/* <Button variant="none" borderRadius="27px" color="#868585" border="1px solid #00000033" w="41px" h="41px" p={0}><HorizontalThreeDot /></Button> */}
                          {(team?.created_by === userProfileInfo?.email || team?.access==='super_admin' || team?.access==='owner') && <Menu placement="bottom-start">
                            <MenuButton>
                              <IconButton
                                variant="none" 
                                borderRadius="27px" 
                                color="#868585" 
                                border="1px solid #00000033" 
                                w="41px" 
                                h="41px" 
                                p={0}
                              >
                                <HorizontalThreeDot />
                              </IconButton>
                            </MenuButton>
                            <Portal>
                              <MenuList>
                                <MenuItem
                                  color="black"
                                  icon={ <EditIcon /> }
                                  onClick={() => editTeam(team.id)}
                                  isDisabled={team?.access === "owner"}
                                >
                                  {t('buttons.edit') || "Edit"}
                                </MenuItem>
                                <MenuItem
                                  color="black"
                                  icon={ <DeleteIcon /> }
                                  onClick={() => askDeleteItem(team)}
                                  isDisabled={team?.access === "owner"}
                                >
                                  {t('buttons.delete') || "Delete"}
                                </MenuItem>
                              </MenuList>
                            </Portal>
                          </Menu>}
                        </HStack>
                      </VStack>
                    </Card>
                  ))}
                </Flex>
              ) : (
                <>
                  {teamInfo?.result?.map((team, index) => (
                    <Card
                      key={index}
                      borderBottom="1px solid #D9D9D9"
                      boxShadow="none"
                      borderRadius="0"
                    >
                      <CardBody p={'15px 10px'}>
                        <HStack alignItems="flex-start">
                          <Avatar
                            name={team?.team_detail?.full_name}
                            src={team?.team_detail?.profile_pic}
                            size="lg"
                          />
                          <VStack alignItems="flex-start" gap={0}>
                            <Text
                              color="#3D5A80"
                              className="name"
                              fontSize="16px"
                              fontWeight="400"
                            >
                              {team?.team_detail?.full_name} -{' '}
                              {startCase(replace(team.access, '_', ' '))}
                            </Text>
                            <Text my={0} fontSize="11px" color="#747474">
                              {team?.team_detail?.position}
                            </Text>
                            <Text my={0} fontSize="10px" color="#9F9F9F">
                              {team?.team_detail?.location}
                            </Text>
                            <NextLink
                              href={`/page/private/${team?.company_page}`}
                              passHref
                            >
                              <Link>
                                <Text
                                  color="#333333"
                                  fontWeight="400"
                                  fontSize="14px"
                                >
                                  {team?.company_name}
                                </Text>
                              </Link>
                            </NextLink>
                            {team.access !== 'owner' && (
                              <HStack>
                                <Button
                                  fontSize="sm"
                                  size="sm"
                                  variant="transparent"
                                  color="#3D5A80"
                                  onClick={() => editTeam(team.id)}
                                  fontWeight="400"
                                  p={0}
                                >
                                  {t('buttons.edit') || "Edit"}
                                </Button>
                                <span> | </span>
                                <Button
                                  fontSize="sm"
                                  size="sm"
                                  variant="transparent"
                                  color="#3D5A80"
                                  onClick={() => askDeleteItem(team)}
                                  fontWeight="400"
                                  p={0}
                                >
                                  {t('buttons.delete') || "Delete"}
                                </Button>
                              </HStack>
                            )}
                          </VStack>
                        </HStack>
                      </CardBody>
                    </Card>
                  ))}
                </>
              )}
            </>
          ) : showTeams ? (
            <Flex justifyContent="center" alignItems="center" h="70%">
              <PermissionImg />
            </Flex>
          ) : null}

          <Box 
            // mt={"50px"} 
            className="row" 
            id="addMemberCompany" 
            p={[3, 0]}
          >
            {addOpen && (
              <>
                <Flex mb="10px" justifyContent="space-between" alignItems="center">
                  {/* <Text fontSize="18px" color="#333333"> */}
                  <Text fontSize={['18px', '15px', '15px', '18px']} color="#333333">
                    {currentTeamId ? t('settingsPermission.updateUser') || 'Update user' : t('settingsPermission.addUser') || 'Add a user'}
                  </Text>
                  <Button variant="ghost" borderRadius="full" onClick={goToCreate}>
                    {/* <Text fontSize="16px" fontWeight="400" color="#333333" me="10px">{t('settingsPermission.addNewPage') || "Add New Page"}</Text> */}
                    <Text fontSize={['16px', '14px', '14px', '16px']} fontWeight="400" color="#333333" me="10px">{t('settingsPermission.addNewPage') || "Add New Page"}</Text>
                    <CircleFilled color="#3D5A80" />
                  </Button>
                </Flex>
                {/* <Text cursor="pointer" mb={2} onClick={openInviteModal} fontSize="18px" color="rgb(61, 90, 128)"> */}
                <Text cursor="pointer" mb={2} onClick={openInviteModal} fontSize={['18px', '15px', '15px', '18px']} color="rgb(61, 90, 128)">
  + {t('settingsPermission.inviteConnection') || "Invite Connection"} 
  </Text>
                <Stack direction={['column', 'row']} spacing="4" mb="20px">
                  {/* <Box flex="1" mt={"10px"}>
                    <Text fontSize="16px" mb={"5px"} color="#737373">
                      Invite Connection
                    </Text>
                    <Popover
                      {...disc}
                      ref={containerRef}
                      matchWidth={true}
                      initialFocusRef={inputRef}
                      placement="bottom-start"
                    >
                      <PopoverTrigger>
                        <Input
                          fontSize="14px"
                          type="text"
                          placeholder="Search name, email"
                          value={searchQuery}
                          onChange={(e) => fieldsOnChange(e)}
                          onKeyUp={(e) => disc?.onOpen?.()}
                          onClick={(e) => disc?.onOpen?.()}
                          name="teamMate"
                          ref={inputRef}
                          isDisabled={isEditing}
                        />
                      </PopoverTrigger>
                      {disc?.isOpen && options?.length > 0 ? (
                        <PopoverContent p={0}>
                          <PopoverBody p={0} w="100%" overflowY="auto">
                            <List>
                              {options.map((option, i) => (
                                <ListItem
                                  _hover={{
                                    bg: 'gray.100',
                                  }}
                                  px={4}
                                  py={2}
                                  key={i}
                                  onClick={handleSelect(option)}
                                >
                                  {option.first_name} {option.last_name}
                                </ListItem>
                              ))}
                            </List>
                          </PopoverBody>
                        </PopoverContent>
                      ) : (
                        ''
                      )}
                    </Popover>
                    {errorFields.teamMate && (
                      <Box as="span" color="red">
                        {errorFields.teamMate}
                      </Box>
                    )}
                  </Box> */}
                  {/* <Box flex="1" mt={"10px"} ref={dropdownRef}>
                    <Text fontSize="16px" mb={"5px"} color="#737373">
                      {t('settingsPermission.inviteConnection') || "Invite Connection"}
                    </Text>
                    <HStack>
                      <Box position="relative" width="100%">
                      <Input
                        fontSize="14px"
                        type="text"
                        placeholder={t('settingsPermission.searchNameEmail') || "Search name, email"}
                        value={searchQuery}
                        onChange={(e) => fieldsOnChange(e)}
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        name="teamMate"
                        ref={inputRef}
                        isDisabled={isEditing}
                        autocomplete="off"
                      />
                        {isDropdownOpen && options?.length > 0 && (
                          <Box
                            position="absolute"
                            top="100%"
                            left="0"
                            width="100%"
                            zIndex="dropdown"
                            bg="white"
                            boxShadow="md"
                            borderRadius="md"
                            mt="2"
                            maxHeight="200px"
                            overflowY="auto"
                          >
                            <List>
                              {options.map((option, i) => (
                                <ListItem
                                  key={i}
                                  onClick={handleSelect(option)}
                                  _hover={{ bg: 'gray.100' }}
                                  cursor="pointer"
                                  p="2"
                                >
                                  <HStack>
                                    <Avatar
                                      size="sm"
                                      name={`${option.first_name} ${option.last_name}`}
                                      src={option.profile_pic}
                                    />
                                    <VStack align="start" spacing="0">
                                      <Text>{`${option.first_name} ${option.last_name}`}</Text>
                                      <Text fontSize="sm" color="gray.500">
                                        {option.position || option.email}
                                      </Text>
                                    </VStack>
                                  </HStack>
                                </ListItem>
                              ))}
                            </List>
                          </Box>
                        )}
                      </Box>
                    </HStack>
                    {errorFields.teamMate && (
                      <Box as="span" color="red">
                        {errorFields.teamMate}
                      </Box>
                    )}
                  </Box> */}
                  <Box display="flex" alignItems="end" flex="1" mt={"10px"} ref={dropdownRef}>

  
<HStack w="100%">
  <Box position="relative" width="100%">
    <Input
      fontSize={['14px', '13px', '13px', '14px']}
      type="text"
      placeholder={t('settingsPermission.searchNameEmail') || "Search name, email"}
      value={searchQuery}
      onChange={(e) => fieldsOnChange(e)}
      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      name="teamMate"
      ref={inputRef}
      isDisabled={true}
      autocomplete="off"
    />
    {/* {isDropdownOpen && options?.length > 0 && (
      <Box
        position="absolute"
        top="100%"
        left="0"
        width="100%"
        zIndex="dropdown"
        bg="white"
        boxShadow="md"
        borderRadius="md"
        mt="2"
        maxHeight="200px"
        overflowY="auto"
      >
        <List>
          {options.map((option, i) => (
            <ListItem
              key={i}
              onClick={handleSelect(option)}
              _hover={{ bg: 'gray.100' }}
              cursor="pointer"
              p="2"
            >
              <HStack>
                <Avatar
                  size="sm"
                  name={`${option.first_name} ${option.last_name}`}
                  src={option.profile_pic}
                />
                <VStack align="start" spacing="0">
                  <Text>{`${option.first_name} ${option.last_name}`}</Text>
                  <Text fontSize="sm" color="gray.500">
                    {option.position || option.email}
                  </Text>
                </VStack>
              </HStack>
            </ListItem>
          ))}
        </List>
      </Box>
    )} */}
  </Box>
</HStack>
{errorFields.teamMate && (
  <Box as="span" color="red">
    {errorFields.teamMate}
  </Box>
)}
</Box>
                  <Box flex="1" mt={"10px"}>
                    {companyPages?.length > 0 ? (
                      <>
                        {/* <Text fontSize="16px" mb={"5px"} color="#737373"> */}
                        <Text fontSize={['16px', '14px', '14px', '16px']} mb={"5px"} color="#737373">
                          {t('profileNetwork.page') || "Page"}*
                        </Text>
                        {/* <Select
                          size="14px"
                          name="companyPage"
                          onChange={(e) => handleChange(e)}
                          placeholder={t('profileNetwork.page') || "Page"}
                          style={{color:"#737373", padding: "10px", fontSize: "14px"}} */}
                        <Select
                          size={['14px', '13px', '13px', '14px']}
                          name="companyPage"
                          onChange={(e) => handleChange(e)}
                          placeholder={t('profileNetwork.page') || "Page"}
                          style={{color:"#737373", padding: "10px"}}
                          fontSize={['14px', '13px', '13px', '14px']}
                          value={fields.companyPage}
                          isDisabled={isEditing}
                          sx={direction === 'rtl' ? {
                            '&': {
                              textAlign: 'left',
                            }
                          } : {}}
                        >
                          {companyPages?.filter((page)=>(page?.access_type==="owner" || page?.access_type==="super_admin")).map((item) => (
                            <option value={item.value} key={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Select>
                      </>
                    ) : (
                      <Text>
                        {t('settingsPermission.noPagesCreated') || "You don't have any pages created. Please create a page."}
                      </Text>
                    )}
                    {errorFields.companyPage && (
                      <Box as="span" color="red">
                        {errorFields.companyPage}
                      </Box>
                    )}
                  </Box>
                </Stack>
                <Box className="col-12">
                  <Radio
                    value="super_admin"
                    onChange={radioChangeHandler}
                    name="role"
                    isChecked={fields.role === 'super_admin'}
                    mb="15px"
                    alignItems="baseline"
                  >
                    {/* <Text fontSize="16px" fontWeight="600">{t('settingsPermission.superAdmin') || "Super admin"}</Text> */}
                    <Text fontSize={['16px', '14px', '14px', '16px']} fontWeight="600">{t('settingsPermission.superAdmin') || "Super admin"}</Text>
                    {/* <Text fontSize="16px" fontWeight="500" className="ms-4 ps-1"> */}
                    <Text fontSize={['16px', '13px', '13px', '16px']} fontWeight="500" className="ms-4 ps-1">
                      {t('settingsPermission.superAdminDescription') || "This role manages everything on the Page. It’s the only role that can edit the Page and manage all admins."}
                    </Text>
                  </Radio>
                  <Radio
                    value="content_admin"
                    name="role"
                    onChange={radioChangeHandler}
                    isChecked={fields.role === 'content_admin'}
                    mb="15px"
                    alignItems="baseline"
                  >
                    {/* <Text fontSize="16px" fontWeight="600">{t('settingsPermission.contentAdmin') || "Content admin"}</Text> */}
                    <Text fontSize={['16px', '14px', '14px', '16px']} fontWeight="600">{t('settingsPermission.contentAdmin') || "Content admin"}</Text>
                    {/* <Text fontSize="16px" fontWeight="500" className="ms-4 ps-1"> */}
                    <Text fontSize={['16px', '13px', '13px', '16px']} fontWeight="500" className="ms-4 ps-1">
                      {t('settingsPermission.contentAdminDescription') || "This role posts and manages content, comments as the Page, exports analytics, post jobs, and manage applicants"}
                    </Text>
                  </Radio>
                  <Radio
                    value="hiring_admin"
                    name="role"
                    onChange={radioChangeHandler}
                    isChecked={fields.role === 'hiring_admin'}
                    mb="15px"
                    alignItems="baseline"
                  >
                    {/* <Text fontSize="16px" fontWeight="600">{t('settingsPermission.hiringAdmin') || "Hiring admin"}</Text> */}
                    <Text fontSize={['16px', '14px', '14px', '16px']} fontWeight="600">{t('settingsPermission.hiringAdmin') || "Hiring admin"}</Text>
                    {/* <Text fontSize="16px" fontWeight="500" className="ms-4 ps-1"> */}
                    <Text fontSize={['16px', '13px', '13px', '16px']} fontWeight="500" className="ms-4 ps-1">
                      {t('settingsPermission.hiringAdminDescription') || "This role post jobs, and move applicants through the hiring process."}
                    </Text>
                  </Radio>
                  {errorFields.role && (
                    <Box color="brandRed.400">{errorFields.role}</Box>
                  )}
                  <Flex gap="4" float="right">
                    {/* {currentTeamId ? ( */}
                      <Button
                        className="btn btn-secondary fw-normal"
                        variant="secondary"
                        onClick={cancelTeam}
                        borderRadius="30px"
                        width="142px"
                        height="47px"
                        color="#3D5A80"
                        fontWeight="600"
                        fontSize={['18px', '15px', '15px', '18px']}
                      >
                        {t('buttons.cancel') || "Cancel"}
                      </Button>
                    {/* ) : (
                      ''
                    )} */}
                    <Button
                      disabled={loading||!fields?.role}
                      // variant="primary"

bg={loading||!fields?.role?"#A6A6A6":"#3D5A80"}

                      onClick={saveTeam}
                      borderRadius="30px"
                      width="222px"
                      height="47px"
                      color="#FFFFFF"
                      fontWeight="600"
                      fontSize={['18px', '15px', '15px', '18px']}
                    >
                      {loading ? (
                        <Spinner />
                      ) : (
                        <>{currentTeamId ? t('settingsPermission.updateUser') || 'Update User' : t('settingsPermission.addUser') || 'Add User'} </>
                      )}
                    </Button>
                  </Flex>
                </Box>
              </>
            )}
          </Box>

          <AlertDialog {...discAlert} isCentered motionPreset="slideInBottom">
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                  {t('settingsPermission.deleteAccess') || "Delete Access"}
                </AlertDialogHeader>

                <AlertDialogBody>
                 {companyName?.access === 'owner'
                  ? `${companyName?.team_detail?.full_name} will lose access to ${companyName?.company_name}.`
                  : `${t('settingsPermission.loseAccess') || "You’ll lose access to"} ${companyName?.company_name}.`}
                </AlertDialogBody>

                <AlertDialogFooter>
                  <Button borderRadius="full" onClick={() => discAlert.onClose()}>{t('buttons.cancel') || "Cancel"}</Button>
                  <Button
                    borderRadius="full"
                    variant="primary"
                    ml={3}
                    onClick={() => handleDeleteTeam(companyName?.id)}
                  >
                    {t('profile.remove') || "Remove"}
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
          <Modal size="3xl" isOpen={inviteModalOpen} onClose={closeInviteModal} isCentered>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>
                <Text color="#3D5A80" fontSize="22px" lineHeight="26px">
                  {t('pages.inviteConnectionsToFollow') || "Invite connections"}
                </Text>
                <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} onClick={closeInviteModal} />
              </ModalHeader>
              <ModalBody>
                <Stack>
                  <HStack>
                    <InputGroup>
                      <Stack position="absolute" zIndex="1" {...(direction === 'rtl') ? {mr: '10px'} : {ml: '10px'}} mt="15px">
                        <SearchLineIcon />
                      </Stack>

                      <Input
                        // pl="40px"
                        {...(direction === 'rtl') ? {pr: "40px"} : {pl: "40px"}}
                        onChange={handleInviteSearch}
                        value={inviteSearch}
                        autoFocus
                        placeholder={t('pages.searchByName') || "Search by name"}
                        borderRadius="30px"
                      />
                    </InputGroup>
                  </HStack>
                  <Divider />
                  {(() => {
                    const filteredOptions = inviteOptions?.filter?.((c) =>
                      inviteSearch?.length
                        ? getUserFullName(c)
                            ?.toLowerCase?.()
                            ?.includes?.(inviteSearch?.toLowerCase?.())
                        : true
                    );

                    if (filteredOptions?.length === 0 && selectedConnections?.length === 0) {
                      return (
                        <VStack justifyContent="center" alignItems="center" py={12} w="100%">
                          <Image
                            src="/images/defaultSearchImage.svg"
                            alt="No users found"
                            width="150px"
                          />
                          <Text fontSize="16px" color="#AFAFAF" fontWeight="500" mt={2}>
                            {t('searchPage.noResultsFound') || "No results found"}
                          </Text>
                        </VStack>
                      );
                    }

                    return (
                      <HStack alignItems="flex-start" w="100%">
                        <Stack maxW="408px" w="380px">
                          {filteredOptions?.length > 0 ? (
                            <List
                              className="member-list"
                              as={Stack}
                              spacing={0}
                              maxH="64"
                              overflowY="hidden"
                              _hover={{ overflowY: 'auto' }}
                            >
                              {filteredOptions.map((c, cIndex) => (
                                <ListItem key={cIndex}>
                                  <HStack w="100%" alignItems="flex-start">
                                    <Checkbox
                                      isChecked={selectedConnections.some(
                                        (selectedItem) => selectedItem.id === c?.id
                                      )}
                                      onChange={() => toggleSelectedConnection(c)}
                                      borderRadius={5}
                                      p={2}
                                      flex={1}
                                      _hover={{ bg: 'gray.100' }}
                                    >
                                      <HStack alignItems="flex-start">
                                        <Avatar
                                          name={getUserFullName(c)}
                                          src={getUserProfilePic(c)}
                                        />
                                        <Stack spacing={0}>
                                          <Text>{getUserFullName(c)}</Text>
                                          <Text fontSize="sm" color="blackAlpha.500">
                                            {c?.position ??
                                              c?.experiences?.[0]?.name ??
                                              c?.educations?.[0]?.name}
                                          </Text>
                                        </Stack>
                                      </HStack>
                                    </Checkbox>
                                  </HStack>
                                </ListItem>
                              ))}
                            </List>
                          ) : (
                            <VStack justifyContent="center" alignItems="center" py={4} w="100%">
                              <Image
                                src="/images/defaultSearchImage.svg"
                                alt="No users found"
                                width="150px"
                              />
                              <Text fontSize="16px" color="#AFAFAF" fontWeight="500">
                                {t('searchPage.noResultsFound') || "No results found"}
                              </Text>
                            </VStack>
                          )}
                        </Stack>
                        {selectedConnections?.length > 0 && (
                          <Divider orientation="vertical" h="247px" />
                        )}
                        <Stack maxW="247px" w="247px">
                          {selectedConnections?.length ? (
                            <List>
                              <HStack justifyContent="space-between" mb={4}>
                                <Stack cursor="pointer">
                                  <Text
                                    fontSize="15px"
                                    color="#868585"
                                    lineHeight="18px"
                                  >
                                    {selectedConnections?.length} {t('pages.selected') || "Selected"}
                                  </Text>
                                </Stack>
                                <Stack cursor="pointer">
                                  <Text
                                    fontSize="15px"
                                    color="#868585"
                                    lineHeight="18px"
                                    onClick={() => setSelectedConnections([])}
                                  >
                                    {t('pages.unselectAll') || "Unselect all"}
                                  </Text>
                                </Stack>
                              </HStack>
                              {selectedConnections?.map?.((c, cIndex) => (
                                <ListItem key={cIndex}>
                                  <HStack w="100%" alignItems="flex-start" mb={3}>
                                    <HStack justifyContent="center" alignItems="center" flex="1">
                                      <Avatar
                                        name={getUserFullName(c)}
                                        src={getUserProfilePic(c)}
                                      />
                                      <Stack spacing={0} flex="1">
                                        <Text>{getUserFullName(c)}</Text>
                                      </Stack>
                                      <Stack
                                        cursor="pointer"
                                        onClick={() => toggleSelectedConnection(c)}
                                      >
                                        <RemoveUserIcon />
                                      </Stack>
                                    </HStack>
                                  </HStack>
                                </ListItem>
                              ))}
                            </List>
                          ) : (
                            ''
                          )}
                        </Stack>
                      </HStack>
                    );
                  })()}
                </Stack>
              </ModalBody>
              <ModalFooter>
                <HStack justifyContent="flex-end">
                  <Button
                    borderRadius='full'
                    onClick={closeInviteModal}
                    variant="secondary"
                  >
                    {t('buttons.cancel') || "Cancel"}
                  </Button>
                  <Button
                    borderRadius="full"
                    variant="primary"
                    onClick={handleInviteConfirm}
                    isDisabled={selectedConnections?.length === 0}
                  >
                    {t('createJob.add') || "Add"} {selectedConnections?.length > 0 ? selectedConnections?.length : ''}
                  </Button>
                </HStack>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Box>
      ) : (
        <SectionLoader />
      )}
    </AuthenticatedProviders>
  );
}
